import api from './api';

export interface PlantFamily {
  value: string;
  label: string;
  scientificName: string;
}

export interface PlantSearchResult {
  value: string;
  label: string;
  scientificName: string;
  commonName: string;
  family: string;
  familyCommonName: string;
  imageUrl: string;
}

export interface PlantFamilyResponse {
  results: PlantFamily[];
  total: number;
}

export interface PlantSearchResponse {
  results: PlantSearchResult[];
  total: number;
}

const skipRedirects = { skipRedirects: true } as any;

export const plantsApi = {
  families: async (query?: string): Promise<PlantFamilyResponse> => {
    const params: Record<string, string> = {};
    if (query) params.q = query;
    const response = await api.get<PlantFamilyResponse>('/api/v1/plants/families', {
      params,
      ...skipRedirects,
    });
    return response.data;
  },

  list: async (family?: string, query?: string, page?: number): Promise<PlantSearchResponse> => {
    const params: Record<string, string | number> = {};
    if (family) params.family = family;
    if (query) params.q = query;
    if (page && page > 1) params.page = page;
    const response = await api.get<PlantSearchResponse>('/api/v1/plants/list', {
      params,
      ...skipRedirects,
    });
    return response.data;
  },

  search: async (query: string): Promise<PlantSearchResponse> => {
    const response = await api.get<PlantSearchResponse>('/api/v1/plants/search', {
      params: { q: query },
      ...skipRedirects,
    });
    return response.data;
  },
};
